import request from "../../../util/request"
import { APP_KEY, PHP_API_URL } from "../../../util/constants";
import Cookies from 'js-cookie'
export function getAliOssTokenRequest( callback) {
    let formData = new FormData();
    formData.append("appkey",APP_KEY);
    formData.append('utoken', Cookies.get("userToken"));
    return request(PHP_API_URL+"/aliyun/osssts.php", {
        method: "POST",
        body: formData
    }, callback);
}
export function getUserInfoRequest( callback) {
    let formData = new FormData();
    formData.append("appkey",APP_KEY);
    formData.append('caozuo', "get_qiantai_user_info");
    formData.append('user_token', Cookies.get("userToken"));
    formData.append('username', Cookies.get("username"));
    return request(PHP_API_URL+"/User/i", {
        method: "POST",
        body: formData
    }, callback);
}

export function updateUserInfoRequest(image_url,name,pwd, callback) {
    let formData = new FormData();
    formData.append("appkey",APP_KEY);
    formData.append('caozuo', "update_qiantai_user_info");
    formData.append('user_token', Cookies.get("userToken"));
    formData.append('username', Cookies.get("username"));
    formData.append('image_url', image_url==null ||image_url=="null" || image_url == "" ? "" : image_url);
    formData.append('name', name);
    formData.append('pwd', pwd);
    return request(PHP_API_URL+"/User/i", {
        method: "POST",
        body: formData
    }, callback);
}